import { z } from 'zod'

import { DateZod } from '../common'

export const ChangedByZod = z.object({
  uid: z.string(),
  username: z.string(),
})

export type ChangedBy = z.infer<typeof ChangedByZod>

/**
 * Constant for system-initiated changes (e.g., initial snapshots when evening opens).
 */
export const SYSTEM_CHANGED_BY: ChangedBy = {
  uid: 'system',
  username: 'system',
}

const BaseConfigurationHistoryEventZod = z.object({
  timestamp: DateZod,
  changedBy: ChangedByZod,
  eveningId: z.number().optional(),
  operatingDate: z.string().optional(),
})

export const AssignmentHistoryEventZod = BaseConfigurationHistoryEventZod.extend({
  type: z.literal('assignment'),
  previousValue: z.enum(['manual', 'trf', 'solver', 'legacy']),
  newValue: z.enum(['manual', 'trf', 'solver', 'legacy']),
})

export const MobileRequestsHistoryEventZod = BaseConfigurationHistoryEventZod.extend({
  type: z.literal('mobileRequests'),
  previousValue: z.boolean(),
  newValue: z.boolean(),
  source: z.enum(['central', 'evening']).optional(),
})

export const WaitTimeHistoryEventZod = BaseConfigurationHistoryEventZod.extend({
  type: z.literal('waitTime'),
  previousValue: z.enum(['default', 'increased']),
  newValue: z.enum(['default', 'increased']),
})

export const AssistedAssignmentHistoryEventZod = BaseConfigurationHistoryEventZod.extend({
  type: z.literal('assistedAssignment'),
  previousValue: z.boolean(),
  newValue: z.boolean(),
})

export const ConfigurationHistoryEventZod = z.discriminatedUnion('type', [
  AssignmentHistoryEventZod,
  MobileRequestsHistoryEventZod,
  WaitTimeHistoryEventZod,
  AssistedAssignmentHistoryEventZod,
])

export type ConfigurationHistoryEvent = z.infer<typeof ConfigurationHistoryEventZod>
export type AssignmentHistoryEvent = z.infer<typeof AssignmentHistoryEventZod>
export type MobileRequestsHistoryEvent = z.infer<typeof MobileRequestsHistoryEventZod>
export type WaitTimeHistoryEvent = z.infer<typeof WaitTimeHistoryEventZod>
export type AssistedAssignmentHistoryEvent = z.infer<typeof AssistedAssignmentHistoryEventZod>
